import { render, staticRenderFns } from "./OrganismDiscovery.vue?vue&type=template&id=2bcad98c&scoped=true&"
import script from "./OrganismDiscovery.vue?vue&type=script&lang=js&"
export * from "./OrganismDiscovery.vue?vue&type=script&lang=js&"
import style0 from "./OrganismDiscovery.vue?vue&type=style&index=0&id=2bcad98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcad98c",
  null
  
)

export default component.exports